export default "__VITE_ASSET__9J5XS6bn__"